import { gql } from "@apollo/client";

const createQuery = async (client, query, queryName, variables = {}) => {
  const { data } = await client.query({
    query,
    variables,
  });
  return data[queryName]?.data;
};

const GET_OPPORTUNITY_IS_ACTIVE = gql`
  query GetActiveOpportunities($userId: Int) {
    getActiveOpportunities(user_id: $userId) {
      data {
        id
        title
        description
        location_id
        division_id
        job_level
        is_open
        created_date
        created_by
        updated_date
        updated_by
        deleted_date
        deleted_by
        Location {
          id
          nama
        }
        Division {
          id
          division
        }
      }
      response {
        status
        errMsg
        id_affected
      }
    }
  }
`;

export const getOpportunityIsActive = async (client, userId) => {
  try {
    const opportunity = await createQuery(
      client,
      GET_OPPORTUNITY_IS_ACTIVE,
      "getActiveOpportunities",
      { userId: userId }
    );
    return opportunity || [];
  } catch (error) {
    return [];
  }
};

const GET_MASTER_DIVISION = gql`
  query Data {
    getMasterDivision {
      data {
        division
        id
      }
      response {
        errMsg
        id_affected
        status
      }
    }
  }
`;

export const getMasterDivision = async (client) => {
  try {
    const division = await createQuery(
      client,
      GET_MASTER_DIVISION,
      "getMasterDivision",
      {}
    );
    return division || [];
  } catch (error) {
    return { errMsg: { error } };
  }
};

const GET_CFIT = gql`
  query Response {
    getCFIT {
      response {
        status
        errMsg
        id_affected
      }
      data {
        id
        section
        question
        question_number
        answer1 {
          image
          score
        }
        answer2 {
          image
          score
        }
        answer3 {
          image
          score
        }
        answer4 {
          image
          score
        }
        answer5 {
          image
          score
        }
        answer6 {
          image
          score
        }
      }
    }
  }
`;

export const getCFIT = async (client) => {
  try {
    const result = await createQuery(client, GET_CFIT, "getCFIT", {});
    return result || [];
  } catch (error) {
    return [];
  }
};

const GET_PAPIKOSTIK = gql`
  query GetPapikostik {
    getPapikostik {
      data {
        id
        number
        option_a {
          option
          score
        }
        option_b {
          option
          score
        }
      }
      response {
        status
        errMsg
        id_affected
      }
    }
  }
`;

export const getPapikostik = async (client) => {
  try {
    const result = await createQuery(
      client,
      GET_PAPIKOSTIK,
      "getPapikostik",
      {}
    );
    return result || [];
  } catch (error) {
    return [];
  }
};

const GET_TIMESTAMP_SECTION_CFIT = gql`
  query Data {
    getCandidateByID {
      data {
        cfit_section_1_date
        cfit_section_2_date
        cfit_section_3_date
        cfit_section_4_date
      }
      response {
        status
      }
    }
  }
`;

export const getTimesCFIT = async (client) => {
  try {
    const result = await createQuery(
      client,
      GET_TIMESTAMP_SECTION_CFIT,
      "getCandidateByID",
      {}
    );
    return result || [];
  } catch (error) {
    return [];
  }
};

const GET_OPPORTUNITY_BY_ID = gql`
  query Data($getOpportunityByIdId: Int!) {
    getOpportunityByID(id: $getOpportunityByIdId) {
      data {
        id
        title
        description
        job_level
        Requirement {
          id
          job_requirement
        }
        Location {
          nama
        }
        Division {
          division
        }
      }
      response {
        status
        errMsg
        id_affected
      }
    }
  }
`;

export const getOpportunityByID = async (client, id) => {
  try {
    const result = await createQuery(
      client,
      GET_OPPORTUNITY_BY_ID,
      "getOpportunityByID",
      { getOpportunityByIdId: id }
    );
    return result || [];
  } catch (error) {
    return { errMsg: error };
  }
};

const GET_OPPORTUNITY_BY_DIVISION_ID = gql`
  query GetOpportunititesByDivisionID($getOpportunititesByDivisionIdId: Int!) {
    getOpportunititesByDivisionID(id: $getOpportunititesByDivisionIdId) {
      data {
        id
        title
        description
        location_id
        division_id
        job_level
        is_open
      }
      response {
        status
        errMsg
        id_affected
      }
    }
  }
`;

export const GetOpportunititesByDivisionID = async (client, id) => {
  try {
    const result = await createQuery(
      client,
      GET_OPPORTUNITY_BY_DIVISION_ID,
      "GetOpportunititesByDivisionID",
      { getOpportunititesByDivisionIdId: id }
    );
    return result || [];
  } catch (error) {
    return { errMsg: { error } };
  }
};

const GET_VERSION_USER = gql`
  query Data {
    getLatestVersionUser {
      data {
        id
        version
        app
      }
      response {
        status
        errMsg
        id_affected
      }
    }
  }
`;

export const getLatestVersionUser = async (client) => {
  try {
    const result = await createQuery(
      client,
      GET_VERSION_USER,
      "getLatestVersionUser",
      {}
    );
    return result || [];
  } catch (error) {
    return { errMsg: { error } };
  }
};

const GET_MASTER_STATUS_CANDIDATE = gql`
  query Response {
    getMasterStatusCandidate {
      response {
        status
        errMsg
        id_affected
      }
      data {
        id
        status
      }
    }
  }
`;

export const getMasterStatusCandidate = async (client) => {
  try {
    const result = await createQuery(
      client,
      GET_MASTER_STATUS_CANDIDATE,
      "getMasterStatusCandidate",
      {}
    );
    return result || [];
  } catch (error) {
    return { errMsg: { error } };
  }
};

const GET_OPPORTUNITY_BY_CANDIDATE_ID = gql`
  query GetOpportunitiesByCandidateID {
    getOpportunitiesByCandidateID {
      data {
        id
        title
        description
        job_level
        is_open
        StatusCandidate {
          updated_date
          created_date
          StatusCandidate {
            id
            status
          }
        }
        Location {
          id
          nama
        }
        Division {
          id
          division
        }
      }
      response {
        status
        errMsg
        id_affected
      }
    }
  }
`;

export const getOpportunitiesByCandidateID = async (client) => {
  try {
    const result = await createQuery(
      client,
      GET_OPPORTUNITY_BY_CANDIDATE_ID,
      "getOpportunitiesByCandidateID",
      {}
    );
    return result || [];
  } catch (error) {
    return { errMsg: { error } };
  }
};

const GET_CANDIDATE_BY_ID_V1 = gql`
  query GetCandidateByID($getCandidateByIdId: Int) {
    getCandidateByID(id: $getCandidateByIdId) {
      data {
        id
        email
        password
        full_name
        short_name
        birth_date
        birth_location
        phone_number
        address
        gender
        married_status
      }
      response {
        status
        errMsg
        id_affected
      }
    }
  }
`;

export const getCandidateByIdv1 = async (client, candidate_id) => {
  try {
    const result = await createQuery(
      client,
      GET_CANDIDATE_BY_ID_V1,
      "getCandidateByID",
      {
        getCandidateByIdId: candidate_id,
      }
    );
    return result || [];
  } catch (error) {
    return { errMsg: { error } };
  }
};

const GET_CANDIDATE_BY_ID = gql`
  query GetCandidateByID {
    getCandidateByID {
      data {
        id
        email
        password
        full_name
        short_name
        link_photo
        phone_number
        address
        gender
        home_owner
        married_status
        birth_date
        birth_location
        ethnic
        nik
        sim
        sim_number
        blood
        home_phone_number
        height
        width
        link_cv
        skills
        cfit_score
        is_pre_assessment_done
        is_papikostik_done
        is_blacklist
        blacklist_reason
        psikotest_date
        medical_checkup_date
        interview_hr_date
        interview_user_date
        mostest1
        mostest2
        cfit_section_1_date
        cfit_section_2_date
        cfit_section_3_date
        cfit_section_4_date
        cfit_second_remaining
        curr_salary
        curr_benefits
        expected_salary
        expected_benefits
        created_date
        updated_date
        deleted_date
        deleted_by
        status_hr_id
        Experiences {
          id
          candidate_id
          company
          job_position
          start_date
          end_date
          is_current
          detail
          created_date
          created_by
          updated_date
          updated_by
          deleted_date
          deleted_by
        }
        Courses {
          id
          candidate_id
          course_category
          course_organizer
          course_year
          link_certificate
          created_date
          updated_date
          deleted_date
        }
        Educations {
          id
          candidate_id
          degree
          graduate_year
          start_year
          is_current
          ipk
          major
          school_name
          created_date
          updated_date
          deleted_date
        }
        CFIT {
          iq
          result
        }
        PreAssessment {
          id
          candidate_id
          answer1
          answer2
          answer3
          answer4
          answer5
        }
        Papikostik {
          id
          candidate_id
          code
          aspect
          score
          interpretation
          created_date
          updated_date
        }
      }
      response {
        status
        errMsg
        id_affected
      }
    }
  }
`;

export const getCandidateByID = async (client) => {
  try {
    const result = await createQuery(
      client,
      GET_CANDIDATE_BY_ID,
      "getCandidateByID",
      {}
    );
    return result || [];
  } catch (error) {
    return { errMsg: { error } };
  }
};

const GET_DETAIL_CANDIDATE_OPPORTUNITY = gql`
  query GetDetailCandidateOpportunity(
    $candidateId: Int!
    $opportunityId: Int!
  ) {
    getDetailCandidateOpportunity(
      candidate_id: $candidateId
      opportunity_id: $opportunityId
    ) {
      data {
        id
        email
        password
        full_name
        short_name
        link_photo
        phone_number
        source_info
        address
        gender
        home_owner
        married_status
        birth_date
        birth_location
        ethnic
        nik
        sim
        sim_number
        blood
        home_phone_number
        height
        width
        link_cv
        skills
        cfit_score
        is_pre_assessment_done
        is_papikostik_done
        is_blacklist
        blacklist_reason
        psikotest_date
        medical_checkup_date
        interview_hr_date
        interview_user_date
        mostest1
        mostest2
        cfit_section_1_date
        cfit_section_2_date
        cfit_section_3_date
        cfit_section_4_date
        cfit_second_remaining
        curr_salary
        curr_benefits
        expected_salary
        expected_benefits
        created_date
        updated_date
        deleted_date
        deleted_by
        status_hr_id
        Experiences {
          id
          candidate_id
          company
          job_position
          start_date
          end_date
          is_current
          detail
          created_date
          created_by
          updated_date
          updated_by
          deleted_date
          deleted_by
        }
        Courses {
          id
          candidate_id
          course_category
          course_organizer
          course_year
          link_certificate
          created_date
          updated_date
          deleted_date
        }
        Educations {
          id
          candidate_id
          degree
          graduate_year
          start_year
          is_current
          ipk
          major
          school_name
          created_date
          updated_date
          deleted_date
        }
        Opportunity {
          id
          created_date
          updated_date
        }
        CFIT {
          iq
          result
        }
        PreAssessment {
          id
          candidate_id
          answer1
          answer2
          answer3
          answer4
          answer5
        }
        Papikostik {
          id
          candidate_id
          code
          aspect
          score
          interpretation
          created_date
          updated_date
        }
      }
      response {
        status
        errMsg
        id_affected
      }
    }
  }
`;

export const getDetailCandidateOpportunity = async (
  client,
  candidate_id,
  opportunity_id
) => {
  try {
    const result = await createQuery(
      client,
      GET_DETAIL_CANDIDATE_OPPORTUNITY,
      "getDetailCandidateOpportunity",
      {
        candidateId: candidate_id,
        opportunityId: opportunity_id,
      }
    );
    return result || [];
  } catch (error) {
    return { errMsg: { error } };
  }
};

const VALIDATE_USER = gql`
  query ValidateUser {
    validateUser {
      data
      response {
        status
        errMsg
        id_affected
      }
    }
  }
`;

export const validateUser = async (client) => {
  try {
    const result = await createQuery(client, VALIDATE_USER, "validateUser", {});
    return result || [];
  } catch (error) {
    return { errMsg: { error } };
  }
};

const GET_LOG_CFIT = gql`
  query GetLogActivityCFIT {
    getLogActivityCFIT {
      data {
        log {
          section
          question_number
          answer
        }
        show_instruction
        cfit_second_remaining
        isSection1Done
        isSection2Done
        isSection3Done
        isSection4Done
      }
      response {
        status
        errMsg
        id_affected
      }
    }
  }
`;

export const getLogActivityCFIT = async (client) => {
  try {
    const result = await createQuery(
      client,
      GET_LOG_CFIT,
      "getLogActivityCFIT",
      {}
    );
    return result || [];
  } catch (error) {
    return { errMsg: { error } };
  }
};

const GET_LOG_PAPIKOSTIK = gql`
  query GetLogActivityPapikostik {
    getLogActivityPapikostik {
      data {
        question_number
        answer
      }
      response {
        status
        errMsg
        id_affected
      }
    }
  }
`;

export const getLogActivityPapikostik = async (client) => {
  try {
    const result = await createQuery(
      client,
      GET_LOG_PAPIKOSTIK,
      "getLogActivityPapikostik",
      {}
    );
    return result || [];
  } catch (error) {
    return { errMsg: { error } };
  }
};

const GET_MASTER_SKILL = gql`
  query GetMasterSkill {
    getMasterSkill {
      data {
        id
        skill
      }
      response {
        status
        errMsg
        id_affected
      }
    }
  }
`;

export const getMasterSkill = async (client) => {
  try {
    const result = await createQuery(
      client,
      GET_MASTER_SKILL,
      "getMasterSkill",
      {}
    );
    return result || [];
  } catch (error) {
    return { errMsg: { error } };
  }
};

const VALIDATE_OTP = gql`
  query ValidateOTP($otp: Int!, $email: String!) {
    validateOTP(otp: $otp, email: $email) {
      data
      response {
        status
        errMsg
        id_affected
      }
    }
  }
`;

export const validateOTP = async (client, otp, email) => {
  try {
    const result = await createQuery(client, VALIDATE_OTP, "validateOTP", {
      otp: otp,
      email: email,
    });
    return result || [];
  } catch (error) {
    return { errMsg: { error } };
  }
};

const IS_EMAIL_EXIST = gql`
  query IsEmailExist($email: String!) {
    isEmailExist(email: $email) {
      data
      response {
        status
        errMsg
        id_affected
      }
    }
  }
`;

export const isEmailExist = async (client, email) => {
  try {
    const result = await createQuery(client, IS_EMAIL_EXIST, "isEmailExist", {
      email: email,
    });
    return result || [];
  } catch (error) {
    return { errMsg: { error } };
  }
};

const IS_PHONENUMBER_EXIST = gql`
  query Response($phoneNumber: String!) {
    isPhoneExist(phone_number: $phoneNumber) {
      data
      response {
        status
        errMsg
        id_affected
      }
    }
  }
`;

export const isPhoneExist = async (client, phone_number) => {
  try {
    const result = await createQuery(
      client,
      IS_PHONENUMBER_EXIST,
      "isPhoneExist",
      {
        phoneNumber: phone_number,
      }
    );
    return result || [];
  } catch (error) {
    return { errMsg: { error } };
  }
};
